module.exports = __webpack_public_path__ + "static/hp_sponsorships_cricket-e37db694f39357f10e230f8c23d3bbb6.jpg";